// import idsrvAuth from "./oidc";
// import Compress from "compress.js";

// export function handleBaseUrl({url}) {
//     const currentUserRole = JSON.parse(window.localStorage.getItem('currentUserRole'))
//     const consultantApi = [
//         {path: 'consultant-inbox', auth: true},
//         {path: 'consultant-transfers', auth: true},
//         {path: 'question-responses', auth: false},
//         {path: 'user', auth: false},
//         {path: 'response-question', auth: false},
//         {path: 'request-settlement', auth: true},
//         {path: 'question-tags', auth: true},
//         {path: 'response-level', auth: true},
//     ]
//     const basePath = url.split("/")[0].split("?")[0]
//     const path = consultantApi.find(item => item.path === basePath)
//     if (path) {
//         if (path.auth || (idsrvAuth.isAuthenticated && currentUserRole === 'consultant')) return "/api/v1/consultant_panel_api/"
//         return "/api/v1/client_ui/"
//     }
//     return "/api/v1/client_ui/"
// }

export function allowedFileTypes(fileType) {
    const types = ["image/jpg", "image/png", "image/jpeg"];
    return types.indexOf(fileType) !== -1
}

export function allowedFileSize(size) {
    return size / 1024 > 1024
}

export async function imageCompressor(file) {
    const compress = new Compress();
    const files = [file];
    const compressedData = await compress.compress(files, {
        size: 1,
        quality: 0.75,
        maxWidth: 1920,
        maxHeight: 1920,
        resize: true
    })
    const dataURI = `${compressedData[0].prefix}${compressedData[0].data}`
    const blob = dataURItoBlob(dataURI)
    return blobToFile(blob);
}

export function blobToFile(blob) {
    const fileName = `${new Date().getTime()}.${blob.type.split("/")[1]}`
    return new File([blob], fileName, {
        lastModified: new Date().getTime(),
        type: blob.type,
    });
}

export function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const _ia = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
    }

    const dataView = new DataView(arrayBuffer);
    return new Blob([dataView], {type: mimeString});
}

export function thousandComma(number) {
  if(number){
    return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}



